import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './style.scss';

function NavigationLink({
  text = '',
  to = '',
  onClick = () => {},
  className = '',
  ...props
}) {
  return (
    <NavLink {...props} to={to} className={`${className}`} onClick={onClick}>
      {text}
    </NavLink>
  );
}

NavigationLink.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
};

export default NavigationLink;
